<template>
  <transition name="notification">
    <div v-show="visibility" class="fixed inset-x-0 inset-y-0" style="background: rgba(255, 255, 255, 0.5);">
      <div
        class="w-80 px-4 py-2 rounded-xl fixed inset-x-0 top-44 mx-auto bg-white text-black border-2 border-black-1">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 inline-block" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
              clip-rule="evenodd" />
          </svg>
          <span class="ml-1 align-middle">{{ content }}</span>
        </div>
        <StandardButton class="float-right w-20 mt-2 bg-black-1 text-white text-base" @click="confirm && confirm(), hidden()">
          确定
        </StandardButton>
        <StandardButton class="border float-right w-20 mt-2 mr-2 bg-white text-black-1 text-base" @click="hidden">取消
        </StandardButton>
      </div>
    </div>

  </transition>
</template>
<script setup>
import { onMounted, ref } from "vue";
import StandardButton from "./StandardButton.vue";

const props = defineProps({
  content: { type: String },
  confirm: { type: Function },
  handleRemove: { type: Function, default: () => { } },
});

const visibility = ref(false);
onMounted(() => {
  visibility.value = true
});

function hidden() {
  visibility.value = false;
  setTimeout(() => {
    props.handleRemove();
  }, 500);
}

</script>
<style scoped>
.notification-enter-active,
.notification-leave-active {
  transition: 0.5s;
}

.notification-enter-from,
.notification-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
